import { defineStore } from 'pinia'
import { jwtDecode } from 'jwt-decode'

import API from '../api/axios'
interface jwtContextUser {
  user_admin: number
  user_email: string
  user_login: string
  user_name: string
  user_role: number
}

interface jwtContext {
  user: jwtContextUser
}
declare module 'jwt-decode' {
  export interface JwtPayload {
    context: jwtContext
  }
}
function safeParse(key, fallback: any = []) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return fallback // null, empty string
    return JSON.parse(raw)
  } catch (e) {
    console.warn(`Invalid JSON in localStorage for key "${key}"`, e)
    return fallback
  }
}
export const useAuthStore = defineStore('auth', {
  //id: 'auth',
  state: () => ({
    // initialize state from local storage to enable user to stay logged in
    userdata: safeParse('userData', {}),
    token: safeParse('HMadminToken', ''),
    status: 'o',
    hasLoadedOnce: false,
    loggedin: typeof localStorage.getItem('userData') != 'string' ? false : true,
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
    authStatus: (state) => state.status,
    hasLoggedOut: (state) => !state.loggedin,
    getUserdata: (state) => state.userdata,
    getRole: (state) =>
      typeof state.userdata.user_role == 'string' ? parseInt(state.userdata.user_role) : state.userdata.user_role,
  },
  actions: {
    async authRequest(inc_user: object) {
      try {
        console.log('try to access api', inc_user)
        const resp = await API.post('/login', inc_user)
        console.log('return api ', resp)
        if (resp.data.Error) throw new Error(resp.data.Error)

        if (!resp.data.jwt) throw new Error('No Token recieved from API')

        this.token = resp.data.jwt
        localStorage.setItem('HMadminToken', this.token)
        //console.log(resp.data)
        const decodedToken = jwtDecode(resp.data.jwt)

        console.log('decode t', decodedToken)
        this.userdata = decodedToken.context.user
        localStorage.setItem('userData', JSON.stringify(this.userdata)) // store the token in localstorage
        this.status = 'success'
        this.loggedin = true
        this.hasLoadedOnce = true
        return resp.data
      } catch (error: any) {
        console.log('errz', error)
        let message = 'Unknown Error'
        if (error instanceof Error) message = error.message
        return { Error: message }
      }
    },

    async authRefresh() {
      try {
        const resp = await API.post('/refresh', this.userdata)
        console.log('auth refresh', resp)
        this.token = resp.data.jwt
        localStorage.setItem('HMadminToken', this.token)
        const decodedToken = jwtDecode(resp.data.jwt)
        this.userdata = decodedToken.context.user
        localStorage.setItem('userData', JSON.stringify(this.userdata)) // store the token in localstorage
        this.status = 'success'
        this.loggedin = true
        this.hasLoadedOnce = true
        return resp
      } catch (err: any) {
        return { Error: err.message }
      }
    },
    /**
     * token from hellomail3 - there called on every axios response with token.
     * really needed? geuss not, as we just refresh the localstorage token on axios response
     * @param tokenstring
     */
    refreshUserData(tokenstring: string) {
      localStorage.setItem('HMadminToken', tokenstring)
      const decodedToken = jwtDecode(tokenstring)
      // console.log(decodedToken)
      this.userdata = decodedToken.context.user
      console.log('refresh userdata with', this.userdata)
      localStorage.setItem('userData', JSON.stringify(this.userdata)) // store the token in localstorage
      this.status = 'success'
      this.loggedin = true
      this.hasLoadedOnce = true
    },
    authLogout() {
      console.log('Logged out')
      localStorage.removeItem('HMadminToken')
      localStorage.removeItem('userData')
      this.token = ''
      this.userdata = {}
      this.loggedin = false
    },
  },
})
